// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b16xTUyFax {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.b16xTUyFax h4 {
  line-height: 3em;
}
.b16xTUyFax .re2Z3uUoYE {
  float: left;
  width: 100%;
}
.b16xTUyFax .iheB0pkGVG {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.b16xTUyFax .iheB0pkGVG:hover {
  cursor: pointer;
}
.b16xTUyFax .iheB0pkGVG:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.R_ovfCJUlC .vdYo_6149w:focus {
  outline: none;
}
.R_ovfCJUlC .vdYo_6149w.v1rEq8fwN5.Ig5iFqdyoL {
  background: #375A88;
}
.R_ovfCJUlC .vdYo_6149w.v1rEq8fwN5.Ig5iFqdyoL span {
  color: #fff;
}
.R_ovfCJUlC .Ig5iFqdyoL {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.R_ovfCJUlC .Ig5iFqdyoL:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.R_ovfCJUlC input {
  height: 38px;
  min-width: 220px;
}
.iheB0pkGVG.f62muFgs_Q {
  background: #410102;
}
.iheB0pkGVG.pVJbNsbIjA {
  background: #911318;
}
.iheB0pkGVG.bUnakAdweS {
  background: #D8293B;
}
.iheB0pkGVG.cINQuihqJ7 {
  background: #F2373C;
}
.iheB0pkGVG.v12zLx1sRC {
  background: #FC4448;
}
.iheB0pkGVG.hWC31q9xgp {
  background: #ED535E;
}
.iheB0pkGVG.FFwlcXKiIH {
  background: #E34926;
}
.iheB0pkGVG.p3hL6JFc7w {
  background: #FC562B;
}
.iheB0pkGVG.P3M4ajVuxa {
  background: #FC6722;
}
.iheB0pkGVG.Tfl7nAuZcm {
  background: #FD7F24;
}
.iheB0pkGVG.C9bnqvWF6D {
  background: #FD8D26;
}
.iheB0pkGVG.IhjpBOHop1 {
  background: #EC9C3E;
}
.iheB0pkGVG.Z3biwL5E3p {
  background: #0e673a;
}
.iheB0pkGVG.kDqY59WBtK {
  background: #208740;
}
.iheB0pkGVG.OAX6Bi7UCD {
  background: #239718;
}
.iheB0pkGVG.wlr7vs_NvM {
  background: #55A84D;
}
.iheB0pkGVG.gQ_gShmAS3 {
  background: #4BBE5A;
}
.iheB0pkGVG.AXKdiEMblk {
  background: #0CCA6A;
}
.iheB0pkGVG.jzzajDcVpB {
  background: #0A3C64;
}
.iheB0pkGVG.V2lTVHpDJy {
  background: #0d487a;
}
.iheB0pkGVG.TnEgptU8Jt {
  background: #10538d;
}
.iheB0pkGVG.mRmVXsP2Fk {
  background: #115A99;
}
.iheB0pkGVG.Aowcc9e2qs {
  background: #3387E2;
}
.iheB0pkGVG.wBYAz_Lyvz {
  background: #1BA9CF;
}
.iheB0pkGVG.PYQLNPFcFi {
  background: #d27c02;
}
.iheB0pkGVG.ewAe8689JK {
  background: #fb9402;
}
.iheB0pkGVG.vc7IWTHab8 {
  background: #FD9B30;
}
.iheB0pkGVG.gX2Gzlkiq9 {
  background: #FDBE2D;
}
.iheB0pkGVG.kEOlsNQ2Vp {
  background: #FED831;
}
.iheB0pkGVG.d9AAaAHtSX {
  background: #FFFD38;
}
.iheB0pkGVG.qalm27y6E0 {
  background: #2D215C;
}
.iheB0pkGVG.Ea2fHRG2uX {
  background: #483C83;
}
.iheB0pkGVG.Y5y1z3oble {
  background: #58518d;
}
.iheB0pkGVG.xM3NzvoDqc {
  background: #7068A9;
}
.iheB0pkGVG.apJcQCup30 {
  background: #7f78b2;
}
.iheB0pkGVG.cqhfsuDjjf {
  background: #8f88bc;
}
.iheB0pkGVG.kxW8cytnj5 {
  background: #000;
}
.iheB0pkGVG.buJReZl9UL {
  background: #282626;
}
.iheB0pkGVG.PvCP4ygbjI {
  background: #242222;
}
.iheB0pkGVG.aDWGuygD_E {
  background: #353838;
}
.iheB0pkGVG.jyNQ7xnI82 {
  background: #666;
}
.iheB0pkGVG.QIlNUGuT2u {
  background: #999;
}
.NsywkaED39 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.NsywkaED39 .fJeIJOS1TT {
  display: none;
}
.TjERzGqMqO {
  margin-bottom: 20px;
}
.TjERzGqMqO .S7nD8Vm6y9 {
  margin-bottom: 16px;
}
.TjERzGqMqO .dqEuxl1q80.dqEuxl1q80 {
  background-color: #ccc;
  color: #000000;
  font-weight: 400;
}
.TjERzGqMqO .cdGE2Fwz7w {
  margin: 0 -24px;
}
.TjERzGqMqO .cdGE2Fwz7w::after {
  content: '';
  display: block;
  border-bottom: 1px solid #fff;
  height: 1px;
  width: 100%;
  position: relative;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `b16xTUyFax`,
	"color-row": `re2Z3uUoYE`,
	"color-tile": `iheB0pkGVG`,
	"picker-component": `R_ovfCJUlC`,
	"picker-element": `vdYo_6149w`,
	"active": `v1rEq8fwN5`,
	"btn": `Ig5iFqdyoL`,
	"red-1": `f62muFgs_Q`,
	"red-2": `pVJbNsbIjA`,
	"red-3": `bUnakAdweS`,
	"red-4": `cINQuihqJ7`,
	"red-5": `v12zLx1sRC`,
	"red-6": `hWC31q9xgp`,
	"orange-1": `FFwlcXKiIH`,
	"orange-2": `p3hL6JFc7w`,
	"orange-3": `P3M4ajVuxa`,
	"orange-4": `Tfl7nAuZcm`,
	"orange-5": `C9bnqvWF6D`,
	"orange-6": `IhjpBOHop1`,
	"green-1": `Z3biwL5E3p`,
	"green-2": `kDqY59WBtK`,
	"green-3": `OAX6Bi7UCD`,
	"green-4": `wlr7vs_NvM`,
	"green-5": `gQ_gShmAS3`,
	"green-6": `AXKdiEMblk`,
	"blue-1": `jzzajDcVpB`,
	"blue-2": `V2lTVHpDJy`,
	"blue-3": `TnEgptU8Jt`,
	"blue-4": `mRmVXsP2Fk`,
	"blue-5": `Aowcc9e2qs`,
	"blue-6": `wBYAz_Lyvz`,
	"yellow-1": `PYQLNPFcFi`,
	"yellow-2": `ewAe8689JK`,
	"yellow-3": `vc7IWTHab8`,
	"yellow-4": `gX2Gzlkiq9`,
	"yellow-5": `kEOlsNQ2Vp`,
	"yellow-6": `d9AAaAHtSX`,
	"purple-1": `qalm27y6E0`,
	"purple-2": `Ea2fHRG2uX`,
	"purple-3": `Y5y1z3oble`,
	"purple-4": `xM3NzvoDqc`,
	"purple-5": `apJcQCup30`,
	"purple-6": `cqhfsuDjjf`,
	"black-1": `kxW8cytnj5`,
	"black-2": `buJReZl9UL`,
	"black-3": `PvCP4ygbjI`,
	"black-4": `aDWGuygD_E`,
	"black-5": `jyNQ7xnI82`,
	"black-6": `QIlNUGuT2u`,
	"picker-theme": `NsywkaED39`,
	"arrow-regular": `fJeIJOS1TT`,
	"add-comment--root": `TjERzGqMqO`,
	"add-comment__uploader--root": `S7nD8Vm6y9`,
	"add-attachment--btn": `dqEuxl1q80`,
	"comment--divider": `cdGE2Fwz7w`
};
export default ___CSS_LOADER_EXPORT___;
